<script lang="ts">
export default {
  name: 'KkUpperTabLayout',
}
</script>

<script lang="ts" setup>
export interface Props {
  menuList?: Record<string, string>
  selectedTabKey?: string
  menuDisabled?: boolean
}

export interface Emits {
  (key: 'click-menu', value: string): void
}

const props = withDefaults(defineProps<Props>(), {
  menuList: () => ({}),
  selectedTabKey: '',
  menuDisabled: false,
})
const emit = defineEmits<Emits>()

</script>

<template>
  <div>
    <div class="p-box">
      <div class="p-box__header">
        <ul class="c-links">
          <li
            v-for="(menu, key) in props.menuList"
            :key="key"
            class="c-links__item"
          >
            <button
              :class="{ active: key === props.selectedTabKey }"
              :disabled="props.menuDisabled"
              type="button"
              @click="emit('click-menu', key)"
            >
              {{ menu }}
            </button>
          </li>
        </ul>
        <slot name="nav-link" />
      </div>

      <div class="p-box__body">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.p-box__header {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    .c-button {
      margin: 0 0 16px auto !important;
    }
    .c-links {
      overflow: scroll hidden;
    }
  }
  .c-links {
    flex-wrap: wrap;
    width: 100%;
    button {
      color: #E9446A;
      &.active {
        color: #3A3B3F;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .c-button {
    margin: 0;
    &__item {
      margin: 0;
    }
  }
}
.p-box__body {
  & :deep(h3) {
    margin-bottom: 16px;
    font-size: 18px;
  }
  & :deep(h4) {
    margin: 32px 0 8px;
    font-size: 12px;
  }
  & :deep(.main-box) {
    & :deep(.c-button) {
      margin: 16px 0;
    }
    & :deep(.c-button__item) {
      margin: 0;
    }
  }
}
</style>
